var angular = require('angular');
require('restangular');
require('lodash');
require('@uirouter/angularjs');

var jsonrpc = require('./client.js').default;

var constants = angular.module('constants', []);

var app = angular.module('amt_admin.server-api', ['restangular', 'ui.router', 'constants', jsonrpc]);

app.service('developer_api', ['jsonrpc', function (jsonrpc) {
    var service = jsonrpc.newService('_develop');
    this.services = service.createMethod('services');
}]);


app.config(['$stateProvider', 'jsonrpcProvider', 'APP_CONFIG',
    function ($stateProvider, jsonrpcProvider, APP_CONFIG) {
        jsonrpcProvider.setBasePath(APP_CONFIG.AMT_ADMIN_URL_PREFIX);

        $stateProvider
            .state('amt.developer.services_methods', {
                url: '/services_method',
                template: '<table class="table">' +
                '<tr ng-repeat="(service_name, methods) in services">' +
                '   <td>{{service_name}}</td>' +
                '   <td>' +
                '       <div ng-repeat="m in methods">{{m}}</div>' +
                '   </td>' +
                '</tr>' +
                '</table>',
                data: {
                    title: 'Admin Api Explorer'
                },
                resolve: {
                    services: ['developer_api', function (developer_api) {
                        return developer_api.services({})
                    }]
                },
                controller: ['$scope', 'services', function ($scope, services) {
                    $scope.services = services;
                }]
            })
    }]);


export default app.name;
